import { render, staticRenderFns } from "./follow-record.vue?vue&type=template&id=1a390446&scoped=true"
import script from "./follow-record.vue?vue&type=script&lang=ts"
export * from "./follow-record.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a390446",
  null
  
)

export default component.exports